import { render } from "./NuovoRapportinoPresenza.vue?vue&type=template&id=5666b18c&scoped=true"
import script from "./NuovoRapportinoPresenza.vue?vue&type=script&lang=js"
export * from "./NuovoRapportinoPresenza.vue?vue&type=script&lang=js"

import "./NuovoRapportinoPresenza.vue?vue&type=style&index=0&id=5666b18c&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1770288832097110005/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5666b18c"]])

export default __exports__